<template>
  <div>
    <div class="pl-2">
      <div class="pt-2">
        <div class="input-group gap-5 abc flex-column">
          <div class="row mb-5">
            <b-form-radio
              v-model="shippedStatus"
              plain
              name="ups"
              value="destination"
              :disabled="isDisabled"
            >
              <h5 class="font-bold">
                {{ $t("usps.choose_only_destination") }}
              </h5>
            </b-form-radio>
            <b-form-radio
              v-model="shippedStatus"
              plain
              name="ups"
              value="shipped"
              :disabled="isDisabled"
              class="ml-2"
            >
              <h5 class="font-bold">
                {{ $t("usps.choose_shipped_from_state") }}
              </h5>
            </b-form-radio>
            <b-form-radio
              v-model="shippedStatus"
              plain
              name="ups"
              value="state"
              :disabled="isDisabled"
              class="ml-2"
            >
              <h5 class="font-bold">
                {{ $t("usps.choose_deliver_date") }}
              </h5>
            </b-form-radio>
          </div>
          <div class="" style="width: 100%">
            <div class="row">
              <div class="col-lg-6 col-12 mb-4">
                <div v-if="shippedStatus === 'destination'" class="d-flex">
                  <div style="width: 50%">
                    <file-pond
                      ref="filePond"
                      required
                      name="file"
                      label-idle="Drag & Drop your CSV file or <span class='filepond--label-action'>Browse</span>"
                      accepted-file-types="text/csv"
                      :files="myFiles"
                      :server="server"
                    />
                  </div>
                  <div
                    class="d-flex flex-column items-center align-items-center pl-4"
                  >
                    <h6 class="fw-semibold text-center">
                      Sample File Destination Zip
                    </h6>
                    <feather-icon
                      size="40"
                      icon="FileTextIcon"
                      class="cursor-pointer"
                      @click="handleDestinationFileClick"
                    />
                  </div>
                </div>

                <div v-if="shippedStatus === 'shipped'" class="d-flex">
                  <div style="width: 50%">
                    <file-pond
                      ref="filePond"
                      required
                      name="file"
                      label-idle="Drag & Drop your CSV file or <span class='filepond--label-action'>Browse</span>"
                      accepted-file-types="text/csv"
                      :files="myFiles"
                      :server="server"
                    />
                  </div>
                  <div
                    class="d-flex flex-column items-center align-items-center pl-4"
                  >
                    <h6 class="fw-semibold text-center">
                      Sample File Destionation Zip and Shipping State
                    </h6>
                    <feather-icon
                      size="40"
                      icon="FileTextIcon"
                      class="cursor-pointer"
                      @click="handleShippedFileClick"
                    />
                  </div>
                </div>

                <div v-if="shippedStatus === 'state'" class="d-flex">
                  <div style="width: 50%">
                    <file-pond
                      ref="filePond"
                      required
                      name="file"
                      label-idle="Drag & Drop your CSV file or <span class='filepond--label-action'>Browse</span>"
                      accepted-file-types="text/csv"
                      :files="myFiles"
                      :server="server"
                    />
                  </div>
                  <div
                    class="d-flex flex-column items-center align-items-center pl-4"
                  >
                    <h6 class="fw-semibold text-center">
                      Sample File Shipped from state and deliver date
                    </h6>
                    <feather-icon
                      size="40"
                      icon="FileTextIcon"
                      class="cursor-pointer"
                      @click="handleStateFileClick"
                    />
                  </div>
                </div>

                <div class="mt-5 mr-3">
                  <div
                    class="alert alert-primary d-flex align-items-start p-1 rounded shadow-sm"
                    role="alert"
                    style="
                      background-color: #0d1b2a;
                      color: #fff;
                      border: 1px solid #1e3a8a;
                    "
                  >
                    <img
                      src="@/assets/images/icons/alert.svg"
                      class="mr-3"
                      alt="alert-icon"
                      width="32"
                      height="32"
                    />
                    <div>
                      <h6 class="mb-2 font-weight-bolder">USP Update</h6>
                      <p class="mb-1">
                        When you choose <strong> delivered </strong> trackings
                        you will get only trackings without proof of delivery.
                        Do you can use the safely and with confidence! Choose
                        only delivered!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Rules Section -->
              <div class="col-lg-6 col-12">
                <div
                  class="mb-2 row justify-content-between align-items-center text-center"
                >
                  <h3>File Formatting Rules</h3>
                  <span
                    v-if="shippedStatus === 'shipped'"
                    class="text-blue cursor-pointer font-weight-bolder"
                    @click="handleStateClick"
                    >Click here to set your preffered shipping states</span
                  >
                </div>
                <p>
                  Please adhere to the following rules when filling out the
                  file:
                </p>
                <ol
                  class="list-group list-group-numbered"
                  style="font-size: 16px"
                >
                  <li class="">
                    <strong>Max 5 days difference between dates:</strong>
                    Ensure that the dateFrom and dateTo have a maximum
                    difference of 5 days between them. This is the interval you
                    will receive tracking shipping date. Delivered by is the
                    date after you want tracking.
                  </li>
                  <li class="">
                    <strong>Same carrier per file:</strong> Include only one
                    carrier per file. Do not mix USPS, UPS, and FedEx in the
                    same file.
                  </li>
                  <li class="">
                    <strong>Date format:</strong> Use the date format
                    <code>dd/MM/yyyy or dd/MM/yy or dd-MM-yyyy</code>. For
                    example,<strong>30/07/2024 or 30/07/24, 30-07-2024 </strong>
                    . No other format is allowed.
                  </li>
                  <li class="">
                    <strong>Tab format:</strong> Ensure each tab follows the
                    specified format for that tab. Different tabs may require
                    different formats.
                  </li>
                  <li class="">
                    <strong>Results:</strong> Check your email for the results
                    with filled TN. Approximate time for 100 numbers is 20 mins.
                    Chek your email after 20 mins.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoadingUPS" class="progress mt-2 loading-bar">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        :style="{ width: progress_s + '%' }"
        aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ progress_s }}%
      </div>
    </div>
  </div>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@/libs/axios";

import {
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BLink,
  BTooltip,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import useJwt from "@/auth/jwt/useJwt";
import CopyToClipboard from "vue-copy-to-clipboard";
import vueFilePond from "vue-filepond";
// eslint-disable-next-line import/no-extraneous-dependencies
import "filepond/dist/filepond.min.css";
// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import WebSocketService from "@/service/WebSocketService";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
);

export default {
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BLink,
    BTooltip,
    BFormCheckbox,
    BFormRadio,
    flatPickr,
    CopyToClipboard,
  },
  props: {
    active: {
      type: String,
    },
  },
  data() {
    return {
      shippedStatus: "destination",
      isLoadingUPS: false,
      progress_s: 0,
      isDisabled: false,
      myFiles: [],
      binary: {},
      getResult: null,
      userEmail: null,
      uploadDestination: {
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          this.handleDestinationFile(file);
        },
      },
      server: {
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          const self = this;
          const ipAddress = localStorage.getItem("ip") || "";
          const formData = new FormData();
          formData.append("multipartFile", file);
          formData.append("ipAddress", ipAddress);
          const url = sessionStorage.getItem("transportURL");
          let id = url;
          if (id !== null) {
            let filename = "ups.csv";
            self.isDisabled = true;
            const request = new XMLHttpRequest();
            const token = localStorage.getItem("accessToken");
            if (this.shippedStatus === "destination") {
              request.open(
                "POST",
                `${axios.defaults.baseURL}/account/api/uploadFile-ups-only-destination/${id}`,
              );
              filename = "UPS_Destination.csv";
            } else if (this.shippedStatus === "shipped") {
              request.open(
                "POST",
                `${axios.defaults.baseURL}/account/api/uploadFile-ups-shipped-from-state/${id}`,
              );
              filename = "UPS_Shipped.csv";
            } else if (this.shippedStatus === "shipped") {
              request.open(
                "POST",
                `${axios.defaults.baseURL}/account/api/uploadFile-ups-shipped-from-state-delivery-date/${id}`,
              );
              filename = "UPS_Shipped.csv";
            }
            request.setRequestHeader("Authorization", `Bearer ${token}`);
            // request.upload.onprogress = (e) => {
            //   progress(e.lengthComputable, e.loaded, e.total);
            // };
            request.onloadstart = function () {
              self.isLoadingUPS = true;
              // self.startProgress();
            };

            WebSocketService.subscribe((message) => {
              self.progress_s = parseFloat(message.toFixed(2));

              if (self.progress_s === 100 && !self.isNotified) {
                self.isNotified = true; // Set the flag to prevent multiple notifications

                const filePond = self.$refs.filePond;
                if (filePond) {
                  self.clearFilePondFiles();
                  self.isDisabled = false;
                  self.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "File Sent Successfully",
                      icon: "EditIcon",
                      variant: "success",
                      text: `Your file has been successfully sent to ${self.userEmail}. Please check your email`,
                    },
                  });
                }

                setTimeout(() => {
                  self.isLoadingUPS = false;
                  self.isNotified = false; // Reset the flag after the operation is complete
                }, 500);
              }
            }, `/topic/progress_${id}`);

            // eslint-disable-next-line func-names
            request.onload = function () {
              if (request.status >= 200 && request.status < 300) {
                // Notify FilePond of successful upload
                load(request.responseText);
                self.progress_s = 0;
                self.isDisabled = false;
              } else {
                self.isLoadingUPS = false;
                self.isDisabled = false;
                const filePond = self.$refs.filePond;
                const res = JSON.parse(request.response);
                const errorMessage =
                  res?.errorMessage || "Upload failed. Please try again.";
                self.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errorMessage,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                });

                // Notify FilePond of the error
                error(errorMessage);

                if (filePond) {
                  filePond.removeFile(filePond.getFile(file.id)); // Clear specific file if needed
                }
              }
            };
            request.onerror = function () {
              self.isDisabled = false;
              // Handle network errors or other unexpected issues
              const errorMessage =
                "An unexpected error occurred. Please try again.";
              self.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });

              // Notify FilePond of the error
              error(errorMessage);
            };
            request.send(formData);
            return {
              abort: () => {
                request.abort();
                abort();
                self.isLoadingUPS = false;
                self.isDisabled = false;
              },
            };
          } else {
            const errorMessage =
              "An unexpected error occurred. Please try again.";
            self.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        },
      },
    };
  },
  watch: {
    shippedStatus(newStatus, oldStatus) {
      if (newStatus) {
        WebSocketService.connect();
      }
      if (newStatus !== oldStatus) {
        this.clearFilePondFiles();
        this.isLoadingUPS = false;
        // WebSocketService.connect();
      }
    },
    active(newVal, oldVal) {
      if (String(newVal) === "1") {
        WebSocketService.connect();
      }
    },
  },
  created() {
    // if (Number(this.active) === 1) {
    //   WebSocketService.connect();
    // }

    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      const parsedUserData = JSON.parse(storedUserData);
      this.userEmail = parsedUserData?.email || "";
    } else {
      this.userEmail;
    }
  },
  beforeDestroy() {
    // Clean up by disconnecting from the WebSocket
    WebSocketService.disconnect();
    sessionStorage.removeItem("transportURL");
  },
  methods: {
    handleStateClick() {
      this.$router.push({ name: "settings" });
      localStorage.setItem("shippingTabNumber", 3);
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          // The result contains the Data URL, extract the Base64 part
          const base64 = reader.result.split(",")[1];
          resolve(base64);
        };

        reader.onerror = (error) => reject(error);

        // Read the file as a Data URL
        reader.readAsDataURL(file);
      });
    },
    startProgress() {
      this.progress = 0;
      this.progressInterval = setInterval(() => {
        if (this.progress < 80) {
          this.progress += 20; // Increment by 20%
        } else {
          clearInterval(this.progressInterval); // Stop incrementing at 100%
          this.progress = 98; // Ensure progress is set exactly to 100%
        }
      }, 700); // Increment every 700ms
    },
    stopProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
    },
    async handleDestinationFile(file) {
      if (file && this.userEmail) {
        const base64String = await this.fileToBase64(file);

        // Establish WebSocket connection and handle messages
        WebSocketService.connect(
          async () => {
            // Subscribe to receive messages
            WebSocketService.subscribe((message) => {
              console.log("Received message:", message);
              // Handle the received message as needed
            });
          },
          (err) => {
            console.error("WebSocket connection error:", err);
            // Stop the progress bar and hide it in case of error
            this.stopProgress();
            this.isLoadingUPS = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  "Unable to connect to the server. Please try again later.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          },
        );

        WebSocketService.subscribe((message) => {
          this.isLoadingUPS = true;
          clearTimeout(this.noMessageTimeout);
          // Handle the received message as needed
          if (message !== undefined) {
            const progressValue = parseFloat(message);

            if (!isNaN(progressValue)) {
              this.progress = progressValue.toFixed(1);

              if (progressValue >= 100) {
                this.progress = 100;
                this.stopProgress();
                this.clearFilePondFiles();
                this.isLoadingUPS = false;

                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "File Sent Successfully",
                    icon: "EditIcon",
                    variant: "success",
                    text: `Your file has been successfully sent to ${this.userEmail}. Please check your email`,
                  },
                });

                // disconnect websocket
                WebSocketService.disconnect();
              }
            }
          }
        });

        // Set a timeout to handle the case where no message is received
        this.noMessageTimeout = setTimeout(() => {
          this.isLoadingUPS = false;
          this.stopProgress();
          this.clearFilePondFiles();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "No Response",
              icon: "AlertTriangleIcon",
              variant: "warning",
              text: "No response received from the server. Please try again later.",
            },
          });

          WebSocketService.disconnect();
        }, 30000); // Set timeout duration (e.g., 30 seconds)

        if (this.shippedStatus === "destination") {
          WebSocketService.sendMessage("/app/uploadFile-ups-only-destination", {
            data: base64String,
            userName: this.userEmail,
          });
        } else if (this.shippedStatus === "shipped") {
          WebSocketService.sendMessage(
            "/app/uploadFile-ups-shipped-from-state",
            {
              data: base64String,
              userName: this.userDetail,
            },
          );
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Something Went Wrong. Please Try Again Later`,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    onResponse(r) {
      this.getResult = r;
    },
    clearFilePondFiles() {
      const filePond = this.$refs.filePond;
      if (filePond) {
        filePond.getFiles().forEach((file) => filePond.removeFile(file.id));
      }
    },
    handleDestinationFileClick() {
      const token = useJwt.getToken();
      useJwt
        .SampleFileUPSDestination(token)
        .then((response) => {
          const csvContent = response.data;
          // Create a Blob from the CSV string
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          // Create a link element and trigger a download
          const link = document.createElement("a");
          if (link.download !== undefined) {
            // For browsers that support the download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute(
              "download",
              "example-ups-only-destination-zip.csv",
            );
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "File Downloaded Successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    handleShippedFileClick() {
      const token = useJwt.getToken();
      useJwt
        .SampleFileUPSShipped(token)
        .then((response) => {
          const csvContent = response.data;
          // Create a Blob from the CSV string
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          // Create a link element and trigger a download
          const link = document.createElement("a");
          if (link.download !== undefined) {
            // For browsers that support the download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute(
              "download",
              "example-ups-destination-zip-and-shipping-state.csv",
            );
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "File Downloaded Successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    handleStateFileClick() {
      const token = useJwt.getToken();
      useJwt
        .sampleFileUSPSOnlyDestination(token)
        .then((response) => {
          const csvContent = response.data;
          // Create a Blob from the CSV string
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          // Create a link element and trigger a download
          const link = document.createElement("a");
          if (link.download !== undefined) {
            // For browsers that support the download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute(
              "download",
              "example-ups-destination-zip-and-shipping-state.csv",
            );
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "File Downloaded Successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.errorMessage}`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.input_container {
  border: 1px solid #e5e5e5;
}

input[type="file"]::file-selector-button {
  background-color: #fff;
  color: #000;
  border: 0px;
  border-right: 1px solid #e5e5e5;
  padding: 10px 15px;
  margin-right: 20px;
  transition: 0.5s;
}

input[type="file"]::file-selector-button:hover {
  background-color: #eee;
  border: 0px;
  border-right: 1px solid #e5e5e5;
}

.loading-bar {
  position: absolute;
  bottom: 60px;
  left: 40px;
}
</style>
